<template>
  <page>
    <div>
      <!-- Add Filters here -->
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex md6>
                          <v-text-field
                            v-model="filter.logType"
                            :label="label.logType"
                            data-vv-name="logType"
                            :data-vv-as="label.logType"
                            :error-messages="errors.collect('logType')"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md6>
                          <v-text-field
                            v-model="filter.logTypeDesc"
                            :label="label.logTypeDesc"
                            data-vv-name="logTypeDesc"
                            :data-vv-as="label.logTypeDesc"
                            :error-messages="errors.collect('logTypeDesc')"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-1"></v-spacer>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class=" mr-2" @click="doNew">
            New Log Type
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              :server-items-length="totalItems"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.logType }}</td>
                  <td class="text-xs-left">{{ row.item.logTypeDesc }}</td>
                  <td class="text-xs-left">{{ formatBooleanToNum(row.item.permitUw) }}</td>
                  <td class="text-xs-left">{{ formatBooleanToNum(row.item.permitCl) }}</td>
                  <td class="table-action-header">
                    <table-action
                      :rowData="row"
                      review
                      @review="doReview(row.item)"
                      query
                      @query="doQuery(row.item)"
                      remove
                      @remove="doPromptRemove(row.item)"
                    ></table-action>
                  </td></tr
              ></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doDelete">
        <p>Are you sure you want to delete the selected Log Type?</p>
        <div class="queryValue">
          Log Type: {{ selected.logType }}<br />
          Description: {{ selected.logTypeDesc }}
        </div>
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'

export default {
  data() {
    return {
      toogleArray: [false],
      loading: false,
      headers: [
        { text: 'Log Type', value: 'logType' },
        { text: 'Description', value: 'logTypeDesc' },
        { text: 'Permit in Underwriting', value: 'permitUw' },
        { text: 'Permit in Claims', value: 'permitCl' },
        TableConst.tableActionHeader
      ],
      label: {
        logType: 'Log Type',
        logTypeDesc: 'Description'
      },
      filter: {
        logType: undefined,
        logTypeDesc: undefined
      },
      totalItems: 0,
      promptRemove: false,
      selected: {
        logType: null,
        logTypeDesc: null,
        permitUw: null,
        permitCl: null
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  async mounted() {
    this.fetchData(true)
    this.doInit()
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async doInit() {
      this.fetchData(true)
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getCustLogTypeList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filter, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  logType: datamap.logType,
                  logTypeDesc: datamap.logTypeDesc,
                  permitUw: datamap.permitUw,
                  permitCl: datamap.permitCl
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doNew() {
      const commit = {
        tranMode: 'New',
        logType: null,
        logTypeDesc: null,
        permitUw: null,
        permitCl: null
      }
      sessionStorage.setItem('logType', JSON.stringify(commit))
      this.$store.commit('CUSTLOGTYPE_COMMIT_KEY', commit)
      this.$router.push({ name: 'custLogTypeReview' })
    },
    doQuery(data) {
      const commit = {
        tranMode: 'Query',
        logType: data.logType,
        logTypeDesc: data.logTypeDesc,
        permitUw: data.permitUw,
        permitCl: data.permitCl
      }
      sessionStorage.setItem('logType', JSON.stringify(commit))
      this.$store.commit('CUSTLOGTYPE_COMMIT_KEY', commit)
      this.$router.push({ name: 'custLogTypeReview' })
    },
    doReview(data) {
      const commit = {
        tranMode: 'Review',
        logType: data.logType,
        logTypeDesc: data.logTypeDesc,
        permitUw: data.permitUw,
        permitCl: data.permitCl
      }
      sessionStorage.setItem('logType', JSON.stringify(commit))
      this.$store.commit('CUSTLOGTYPE_COMMIT_KEY', commit)
      this.$router.push({ name: 'custLogTypeReview' })
    },
    doPromptRemove(data) {
      if (data) {
        this.selected.logType = data.logType
        this.selected.logTypeDesc = data.logTypeDesc
        this.selected.permitUw = data.permitUw
        this.selected.permitCl = data.permitCl
        this.promptRemove = true
      }
    },
    async doDelete() {
      this.resetMessages()
      if (this.selected && this.selected.logType) {
        const apiURI = this.menu.deleteCustLogType
        if (apiURI) {
          const expand = {
            logType: this.selected.logType,
            logTypeDesc: this.selected.logTypeDesc,
            permitUw: this.selected.permitUw,
            permitCl: this.selected.permitCl
          }
          this.$http
            .post(apiURI, expand)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.fetchData(false)
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filter.logType = undefined
      this.filter.logTypeDesc = undefined
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    formatBooleanToNum(value) {
      if (value) {
        return '1'
      }
      return '0'
    }
  },
  computed: {
    menu() {
      return this.$store.state.custLogTypeParam.menu
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
